import getImageUrl, { IMGIX } from '@/utils/images';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  left: 18%;
  position: absolute;
  top: 23px;
  z-index: 1;
`;

export default function QuickShipBadge({ width, className = '' }) {
  return (
    <Wrapper className={className}>
      <img
        src={getImageUrl('icons/quick_ship_badge.svg', IMGIX)}
        alt="Quick Ship Badge"
        style={{ width }}
      />
    </Wrapper>
  );
}
